module.exports = __webpack_public_path__ + "static/media/note-arrow-up.f44b7571.svg";